"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackMode = void 0;
var FeedbackMode;
(function (FeedbackMode) {
    FeedbackMode["SHOW"] = "show";
    FeedbackMode["HIDE_ALL"] = "hide";
    FeedbackMode["HIDE_FEEDBACK"] = "hideFeedback";
    FeedbackMode["HIDE_ICON"] = "hideIcon";
})(FeedbackMode || (exports.FeedbackMode = FeedbackMode = {}));
